export default __webpack_public_path__ + "static/activity-audit-dark-dc26baa09762968c5fac251e798920da.png";